import { useRef } from "react";
import {
	Locatable,
	LocationDescriptionState,
	useLocationDescription,
} from "./use-location-description";
import { VelavuSite } from "velavu-js-api";

export type CachedLocationDescription =
	| {
			state: LocationDescriptionState.OK;
			lines: string[];
	  }
	| {
			state: Exclude<
				LocationDescriptionState,
				LocationDescriptionState.OK
			>;
			lines: string[] | undefined;
	  };

/**
 * A helper that wraps useLocationDescription, and returns
 * the last successful description.
 */
export function useCachedLocationDescription(
	locatable: Locatable | undefined,
	site?: VelavuSite,
): CachedLocationDescription {
	//Look up the description
	const description = useLocationDescription(locatable, site);

	//Cache the description if it's successful
	const cachedDescription = useRef<string[] | undefined>(
		description.state === LocationDescriptionState.OK
			? description.lines
			: undefined,
	);
	if (description.state === LocationDescriptionState.OK) {
		cachedDescription.current = description.lines;
	}

	if (description.state === LocationDescriptionState.OK) {
		return {
			state: description.state,
			lines: description.lines,
		};
	} else {
		return {
			state: description.state,
			lines: cachedDescription.current,
		};
	}
}
